/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const BurnType = {
  Burn: "burn",
  Fee: "fee",
  Total: "total",
} as const;
export type BurnType = ClosedEnum<typeof BurnType>;

export type ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest =
  {
    ledgerCanisterId: string;
    start?: number | undefined;
    end?: number | undefined;
    burnType?: BurnType | undefined;
  };

/** @internal */
export const BurnType$inboundSchema: z.ZodNativeEnum<typeof BurnType> = z
  .nativeEnum(BurnType);

/** @internal */
export const BurnType$outboundSchema: z.ZodNativeEnum<typeof BurnType> =
  BurnType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace BurnType$ {
  /** @deprecated use `BurnType$inboundSchema` instead. */
  export const inboundSchema = BurnType$inboundSchema;
  /** @deprecated use `BurnType$outboundSchema` instead. */
  export const outboundSchema = BurnType$outboundSchema;
}

/** @internal */
export const ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$inboundSchema:
  z.ZodType<
    ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    burn_type: BurnType$inboundSchema.default("burn"),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "burn_type": "burnType",
    });
  });

/** @internal */
export type ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$Outbound =
  {
    ledger_canister_id: string;
    start?: number | undefined;
    end?: number | undefined;
    burn_type: string;
  };

/** @internal */
export const ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$outboundSchema:
  z.ZodType<
    ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$Outbound,
    z.ZodTypeDef,
    ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    burnType: BurnType$outboundSchema.default("burn"),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      burnType: "burn_type",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$ {
  /** @deprecated use `ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$inboundSchema;
  /** @deprecated use `ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$outboundSchema;
  /** @deprecated use `ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$Outbound` instead. */
  export type Outbound =
    ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$Outbound;
}

export function listTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequestToJSON(
  listTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest:
    ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest,
): string {
  return JSON.stringify(
    ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$outboundSchema
      .parse(
        listTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest,
      ),
  );
}

export function listTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest' from JSON`,
  );
}
